import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

// Components.
import Button from '../../01-atoms/Button/Button';
import Constraint from '../../01-atoms/Constraint/Constraint';
import Text from '../../01-atoms/Text/Text';

// Styles.
import './OrderKitOrUploadDataSection.css';

const uploadImgProps = {
  alt: `Photo of DNA Test Kits`,
  className: `OrderKitOrUploadDataSection__upload-illustration-image`,
};
const productImgProps = {
  alt: `Photo of DNA Test Kits`,
  className: `OrderKitOrUploadDataSection__order-illustration-image`,
};

const PureOrderKitOrUploadDataSection = ({ images, semanticLevel = 1 }) => (
  <section className="OrderKitOrUploadDataSection">
    <Constraint className="OrderKitOrUploadDataSection__Constraint">
      <div className="OrderKitOrUploadDataSection__card">
        <div className="OrderKitOrUploadDataSection__card-split">
          <div className="OrderKitOrUploadDataSection__section OrderKitOrUploadDataSection__section--order">
            <div className="OrderKitOrUploadDataSection__figure OrderKitOrUploadDataSection__figure--product-shot ">
              <GatsbyImage image={images.product.fixed} {...productImgProps} />
              <GatsbyImage image={images.product.fluid} {...productImgProps} />
            </div>
            <Text
              className="OrderKitOrUploadDataSection__kit-heading"
              semanticLevel={semanticLevel}
            >
              Order kits for DNA Testing and Whole&nbsp;Genome&nbsp;Sequencing
            </Text>
            <div className="OrderKitOrUploadDataSection__button">
              <Button cta href="/tests/order/genome-sequencing-dna-testing">
                Order DNA kits
              </Button>
            </div>
          </div>

          <div className="OrderKitOrUploadDataSection__section OrderKitOrUploadDataSection__section--upload">
            <div className="OrderKitOrUploadDataSection__figure OrderKitOrUploadDataSection__figure--upload-illustration">
              <GatsbyImage
                image={images.uploadIllustration.fixed}
                {...uploadImgProps}
              />
              <GatsbyImage
                image={images.uploadIllustration.fluid}
                {...uploadImgProps}
              />
            </div>
            <Text
              className="OrderKitOrUploadDataSection__kit-heading"
              semanticLevel={semanticLevel}
            >
              Upload DNA Data from&nbsp;any&nbsp;DNA&nbsp;Test
            </Text>
            <div className="OrderKitOrUploadDataSection__button">
              <Button cta href="/data/upload">
                Free DNA upload
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Constraint>
  </section>
);

const withImages = (Component) => (props) => (
  <StaticQuery
    query={graphql`
      {
        img_products: file(
          absolutePath: {
            glob: "**/section-specific/OrderKitOrUploadDataSection/Ultimate-DNA-Test-and-Whole-Genome-Sequencing-Kits-SequencingCom.png"
          }
          sourceInstanceName: { eq: "images" }
        ) {
          narrow: childImageSharp {
            gatsbyImageData(width: 900, quality: 80, layout: CONSTRAINED)
          }
          wide: childImageSharp {
            gatsbyImageData(width: 450, quality: 100, layout: FIXED)
          }
        }
        img_upload_illustration__narrow: file(
          absolutePath: {
            glob: "**/section-specific/OrderKitOrUploadDataSection/providers-illustration--narrow.png"
          }
          sourceInstanceName: { eq: "images" }
        ) {
          childImageSharp {
            gatsbyImageData(width: 335, quality: 80, layout: CONSTRAINED)
          }
        }
        img_upload_illustration__wide: file(
          absolutePath: {
            glob: "**/section-specific/OrderKitOrUploadDataSection/providers-illustration--wide.png"
          }
          sourceInstanceName: { eq: "images" }
        ) {
          childImageSharp {
            gatsbyImageData(width: 474, quality: 100, layout: FIXED)
          }
        }
      }
    `}
    render={(data) => (
      <Component
        {...props}
        images={{
          product: {
            fixed: data.img_products.wide.gatsbyImageData,
            fluid: data.img_products.narrow.gatsbyImageData,
          },
          uploadIllustration: {
            fluid:
              data.img_upload_illustration__narrow.childImageSharp
                .gatsbyImageData,
            fixed:
              data.img_upload_illustration__wide.childImageSharp
                .gatsbyImageData,
          },
        }}
      />
    )}
  />
);

export { PureOrderKitOrUploadDataSection, withImages };
export default withImages(PureOrderKitOrUploadDataSection);
